// Apex (sem subdominio de encontro) — painel global do ROOT
const APEX_HOSTS = ['checkin.naelshaday.com.br', 'www.checkin.naelshaday.com.br']

export function getEncontroSlug() {
  const host = window.location.hostname

  // Apex sempre retorna null
  if (APEX_HOSTS.includes(host)) return null

  // Localhost dev: pega ?encontro=slug ou usa 'encontro' como default
  if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')) {
    const params = new URLSearchParams(window.location.search)
    return params.get('encontro') || localStorage.getItem('dev_encontro_slug') || 'encontro'
  }

  // checkin.naelshaday.com.br sem prefixo (apex)
  if (host === 'checkin.naelshaday.com.br') return null

  // <slug>.checkin.naelshaday.com.br
  const match = host.match(/^([a-z0-9][a-z0-9-]*)\.checkin\.naelshaday\.com\.br$/)
  return match ? match[1] : null
}

export function isApex() {
  return getEncontroSlug() === null
}

export function encontroUrl(slug) {
  if (!slug) return 'https://checkin.naelshaday.com.br'
  return `https://${slug}.checkin.naelshaday.com.br`
}
